import { memo, } from "react"
import { Divider, Grid2, Skeleton } from "@mui/material"
import Container from "../Container"


const ServiceCardSkeleton = memo(({ hideButtons = false }: { hideButtons?: boolean }) => {

    return (
        <Grid2 container size={'grow'} minWidth={{ xs: '100%', lg: '18vw' }} flexDirection={'column'} borderRadius={2} overflow={'hidden'} bgcolor={'rgba(0,0,0,0.05)'}>
            <Grid2 height={'25vh'} padding={'5%'} sx={{
                backgroundColor: 'rgba(0,0,0,0.05)',
            }}>
                <Grid2 container display={'flex'} justifyContent={hideButtons ? 'end' : 'space-between'}>
                    <Container container size={'auto'} display={hideButtons ? 'none' : 'flex'} alignItems={'center'} paddingX={1} spacing={2} sx={{ backgroundColor: 'rgba(0,0,0,0.05)', backdropFilter: 'none' }}>
                        <Grid2 paddingY={2}>
                            <Skeleton variant="circular" width={30} height={30} />
                        </Grid2>
                        <Grid2 paddingY={2}>
                            <Skeleton variant="circular" width={30} height={30} />
                        </Grid2>
                    </Container>
                    <Grid2 width={{ xs: 50, lg: '4vw' }} height={{ xs: 50, lg: '4vw' }}>
                        <Skeleton variant="circular" width={'100%'} height={'100%'} />
                    </Grid2>
                </Grid2>

            </Grid2>
            <Grid2 container size={'grow'} justifyContent={'space-between'} flexDirection={'column'} zIndex={2} padding={2} spacing={1}>
                <Grid2>
                    <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                </Grid2>
                <Divider flexItem />
                <Grid2 paddingTop={2}>
                    <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                </Grid2>
                <Grid2 container flexDirection={'column'} spacing={0} paddingTop={2}>
                    <Grid2>
                        <Skeleton variant="text" sx={{ fontSize: '3rem' }} />
                    </Grid2>
                </Grid2>
            </Grid2>
        </Grid2>
    )
})

export default ServiceCardSkeleton